import React, { useState, useEffect, useRef } from "react";
import Container from "../../../components/layout/Container/Container";
import {
  getFileProcessRecords,
  getMicrochipRegistrations,
  getScientificNames,
} from "../../../api/apimethods";
import CITESGrid from "./CITESGrid";
import { IMicrochipRegistrationResponseModel } from "../../../typings/models/MicrochipRegistrationResponseModel";
import { useLocation } from "react-router-dom";
import { AppContext, defaultAppContextData } from "../../../services/appData";
import { useAuthService, useContextService } from "../../../services";
import FileProcessDashboard from "../Microchip/Pets/FileProcessDashboard";
import { IFileProcessModel } from "../../../typings/models/FileProcessModel";
import { NotifyType } from "../../../utils/app-config";
import { notify } from "../../../utils";

interface TabPhillProfileProps {
  RegistrationType: any;
}

interface Option {
  value: string;
  label: string;
}

const CITESDashboard: React.FC<TabPhillProfileProps> = ({
  RegistrationType,
}) => {
  const { getContextValueFromStorage } = useContextService();
  const [contextData] = useState(() =>
    getContextValueFromStorage(defaultAppContextData)
  );
  const user = contextData.user;
  const { message } = notify();
  const inspectionRef = useRef(true);
  const [data, setData] = useState<IMicrochipRegistrationResponseModel[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [sRegistrationType, setsRegistrationType] = useState<number>(0);
  const [scientificNames, setScientificNames] = useState<Option[]>([]);
  const [fileProcessData, setFileProcessData] = useState<IFileProcessModel[]>(
    []
  );

  const location = useLocation();
  const regType = location.state?.RegistrationType;
  const regId = location.state?.id;
  const isFromRegistrationLink =
    location.state?.from === "/application-registration";

  let RegType = isFromRegistrationLink
    ? "harvest"
    : regType === "DragonFish" || regId === 3
    ? "DragonFish"
    : regType === "Crocodile" || regId === 2
    ? "Crocodile"
    : "Birds";

  // Fetch data from API on component mount
  // useEffect(() => {
  //   let registrationType = 1;
  //   if (
  //     RegistrationType !== null &&
  //     RegistrationType !== undefined &&
  //     RegistrationType.RegistrationType !== undefined
  //   )
  //     RegType = RegistrationType.RegistrationType.RegistrationType;

  //   if (
  //     RegistrationType === "DragonFish" ||
  //     (RegistrationType !== null &&
  //       RegistrationType !== undefined &&
  //       RegistrationType.RegistrationType === "DragonFish") ||
  //     RegType === "DragonFish" ||
  //     regType === 3
  //   ) {
  //     setsRegistrationType(3);
  //     registrationType = 3;
  //   } else if (
  //     RegistrationType === "Crocodile" ||
  //     (RegistrationType !== null &&
  //       RegistrationType !== undefined &&
  //       RegistrationType.RegistrationType === "Crocodile") ||
  //     RegType === "Crocodile" ||
  //     regType === 2
  //   ) {
  //     setsRegistrationType(2);
  //     registrationType = 2;
  //   } else {
  //     setsRegistrationType(1);
  //     registrationType = 1;
  //   }
  //   if (inspectionRef.current) {
  //     inspectionRef.current = false;
  //     const fetchData = async () => {
  //       try {
  //         const response = await getMicrochipRegistrations(
  //           user.idNo,
  //           registrationType,
  //           ""
  //         );
  //         setData(response.data);
  //         setIsLoading(false);
  //       } catch (error) {
  //         setIsLoading(false);
  //         console.error("Error fetching data:", error);
  //       }
  //     };

  //     fetchData();
  //   }

  //   const scientificNames = async () => {
  //     try {
  //       let response = null;
  //       let category = "Birds";

  //       if (registrationType === 1) {
  //         category = "Birds";
  //       } else if (registrationType === 2) {
  //         category = "Crocodile";
  //       } else if (registrationType === 3) {
  //         category = "DragonFish";
  //       }

  //       response = await getScientificNames(category);

  //       if (response.data) {
  //         const data = response.data;

  //         const apiOptions: Option[] = data.map((item: any) => ({
  //           value: item.id.toString(),
  //           label: item.scientificNameCommonName,
  //         }));

  //         setScientificNames(apiOptions);
  //       } else {
  //         throw new Error("No data received from the API.");
  //       }
  //     } catch (error) {
  //       console.error("Error fetching scientific names:", error);
  //       message(
  //         NotifyType.Error,
  //         "Failed to fetch scientific names. Please try again."
  //       );
  //     }
  //   };

  //   scientificNames();
  // }, []);

  useEffect(() => {
    let registrationType = 1;
    if (
      RegistrationType !== null &&
      RegistrationType !== undefined &&
      RegistrationType.RegistrationType !== undefined
    )
      RegType = RegistrationType.RegistrationType.RegistrationType;
    if (location.state?.from === "/application-registration") {
      setsRegistrationType(3);

      registrationType = 3;
    } else if (
      RegistrationType === "DragonFish" ||
      (RegistrationType !== null &&
        RegistrationType !== undefined &&
        RegistrationType.RegistrationType === "DragonFish") ||
      RegType === "DragonFish" ||
      regType === 3
    ) {
      setsRegistrationType(3);
      registrationType = 3;
    } else if (
      RegistrationType === "Crocodile" ||
      (RegistrationType !== null &&
        RegistrationType !== undefined &&
        RegistrationType.RegistrationType === "Crocodile") ||
      RegType === "Crocodile" ||
      regType === 2
    ) {
      setsRegistrationType(2);
      registrationType = 2;
    } else {
      setsRegistrationType(1);
      registrationType = 1;
    }

    if (inspectionRef.current) {
      inspectionRef.current = false;
      const fetchData = async () => {
        try {
          const response = await getMicrochipRegistrations(
            user.idNo,
            registrationType,
            ""
          );
          setData(response.data);
          setIsLoading(false);
        } catch (error) {
          setIsLoading(false);
          console.error("Error fetching data:", error);
        }
      };

      fetchData();
    }

    const scientificNames = async () => {
      try {
        let category = "Birds";

        if (location.state?.from === "/application-registration") {
          category = "harvest";
        } else if (registrationType === 1) {
          category = "Birds";
        } else if (registrationType === 2) {
          category = "Crocodile";
        } else if (registrationType === 3) {
          category = "DragonFish";
        }

        const response = await getScientificNames(category);

        if (response.data) {
          const apiOptions: Option[] = response.data.map((item: any) => ({
            value: item.id.toString(),
            label: item.scientificNameCommonName,
          }));

          setScientificNames(apiOptions);
        } else {
          throw new Error("No data received from the API.");
        }
      } catch (error) {
        console.error("Error fetching scientific names:", error);
        message(
          NotifyType.Error,
          "Failed to fetch scientific names. Please try again."
        );
      }
    };

    scientificNames();
    const getFileProcessData = async () => {
      try {
        let category = "harvest";

        if (location.state?.from === "/application-registration") {
          category = "harvest";
        } else {
          if (registrationType === 1) category = "Birds";
          else if (registrationType === 2) category = "Crocodile";
          else if (registrationType === 3) category = "DragonFish";
        }

        const response = await getFileProcessRecords(category, user.idNo);
        setFileProcessData(response.data);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.error("Error fetching data:", error);
      }
    };

    getFileProcessData();
  }, [location.state]);

  return (
    <>
      {/* <Header /> */}
      <Container>
        {/* <Banner name="DragonFish all schedule tasks" uiClass="banner-bg" /> */}
        {/* <h3>My all tasks</h3> */}
        <div>
          <CITESGrid
            data={data}
            isLoading={isLoading}
            registrationType={sRegistrationType}
            scientificNames={scientificNames}
          />
        </div>

        <div>
          <FileProcessDashboard data={fileProcessData} />
        </div>
      </Container>
    </>
  );
};

export default CITESDashboard;
